import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {CalendarFormat} from '@domain/calendar/schedule/custom-settings/calendar-format.enum';
import {StartOfDay} from '@domain/calendar/schedule/custom-settings/start-of-day.enum';
import {StartOfWeek} from '@domain/calendar/schedule/custom-settings/start-of-week.enum';
import {EnumUtils, NavigationHelperPrototypeService, TabsMenuItem} from '@vdw/angular-component-library';
import {ScheduleCustomSettingsForm} from './schedule-custom-settings.form';

@Component({
  selector: 'app-schedule-custom-settings',
  templateUrl: './schedule-custom-settings.component.html',
  styleUrls: ['./schedule-custom-settings.component.scss']
})
export class ScheduleCustomSettingsComponent implements OnInit {
  public scheduleForm: ScheduleCustomSettingsForm;
  public readonly calenderFormats = EnumUtils.getEnumValues(CalendarFormat);
  public readonly startOfWeekFormats = EnumUtils.getEnumValues(StartOfWeek);
  public readonly startOfDayFormats = EnumUtils.getEnumValues(StartOfDay);

  protected SCHEDULE_TRANSLATION_KEY = 'CALENDAR.SCHEDULE.SCHEDULE';
  protected generalTab: TabsMenuItem = {
    value: 'generalTab',
    translationKey: 'GENERAL.GENERAL'
  };

  public constructor(
    private readonly navigationHelper: NavigationHelperPrototypeService,
    private readonly formBuilder: FormBuilder
  ) {}

  public ngOnInit(): void {
    this.setFormFields();
  }

  protected navigateBack(): void {
    this.navigationHelper.navigateBack();
  }

  private setFormFields(): void {
    this.scheduleForm = this.formBuilder.group({
      calendarFormat: [CalendarFormat.STANDARD_GREGORIAN],
      startOfWeek: [StartOfWeek.MONDAY],
      startOfDay: [StartOfDay.FIRST_SHIFT_START]
    });
  }
}
